import { FinancingActions } from './financingActionTypes';
import type { SetFinancingInitialTabAction } from './types';

export const setFinancingInitialTab = (tab: 'buyer' | 'insurance'): SetFinancingInitialTabAction => ({
    type: FinancingActions.SET_FINANCING_INITIAL_TAB,
    payload: tab
});
